import { Mutation } from "../types";
import axios from "axios";

export default {
  [Mutation.SET_TOKEN](state, token) {
    return new Promise(function (resolve, reject) {
      state.token = token;
      localStorage.setItem('token', token);
      axios.defaults.headers.common["Authorization"] = token;
      resolve();
    });
  },
  [Mutation.LOGOUT](state) {
    state.token = '';
    window.localStorage.removeItem('vuex');
    localStorage.setItem('token', '');
    axios.defaults.headers.common["Authorization"] = '';
  }
};
